export enum PLANS_SUB_TYPES{
    PREMIUM_POSTPAID = 10
}
export enum SIM_TYPE {
    PHYSICAL_SIM='PHYSICAL_SIM',
    ESIM='ESIM',
    VOUCHER_SIM = 'VOUCHER_SIM',
    BLANK_SIM = 'BLANK_SIM'
}

export enum SIM_TYPE_ORIENTATION {
    PHYSICAL_SIM_UAE_PASS='PHYSICAL_SIM_UAE_PASS',
    PHYSICAL_SIM_FR='PHYSICAL_SIM_FR',
    ESIM_UAE_PASS='ESIM_UAE_PASS',
    ESIM_FR='ESIM_FR',
    VERIFY_IN_PERSON= 'VERIFY_IN_PERSON'
  }